<template>
	<form action class="s-form">
		<div v-for="(step, index) in steps" v-bind:key="index" class="s-form__steps">
			<div v-show="index === currentStep" class="s-form__step">
				<fieldset class="ln-form__fieldset">
					<legend class="mdc-typography--headline2 s-form__title">
						{{ index + 1 }}. {{ step.title[locale] }}
					</legend>
					<div
						v-for="(option, optionIndex) in step.options"
						v-bind:key="optionIndex"
						class="ln-form__row-group"
					>
						<Input v-bind:step="step" v-bind:option="option" v-bind:locale="locale" />

						<fieldset
							v-if="option.sub"
							v-bind:disabled="step.value !== option.value"
							class="ln-form__fieldset s-form__substep mdc-typography"
						>
							<legend class="ln-form__legend">{{ option.sub.title[locale] }}</legend>
							<p v-if="option.sub.description">
								{{ option.sub.description[locale] }}
							</p>
							<div
								v-for="(subOption, subOptionIndex) in option.sub.options"
								v-bind:key="subOptionIndex"
							>
								<Input
									v-bind:step="option.sub"
									v-bind:option="subOption"
									v-bind:locale="locale"
								/>
							</div>
							<div
								v-if="option.sub.details"
								v-html="option.sub.details[locale]"
								class="s-form__details"
							/>
						</fieldset>
					</div>
				</fieldset>
			</div>
		</div>
	</form>
</template>

<script>
import Input from './Input.vue';

export default {
	name: 'Form',
	props: {
		steps: Array,
		currentStep: Number,
		i18n: Object,
		locale: {
			type: String,
			default: 'de'
		}
	},
	components: {
		Input
	}
};
</script>

<style lang="scss">
.s-app .s-form {
	@import '@legacynotes/frontend/src/assets/css/variables-new';
	@import '@legacynotes/frontend/src/assets/css/mixins-new';

	.ln-form__fieldset {
		border: none;
		padding: 0;
		margin: 0;
	}
	.ln-form__legend {
		padding-left: 0;
		font-weight: bold;
		margin-bottom: -1.4em;
	}
	.ln-form__row-group {
		display: block;
		max-width: 692px;

		&:not(:last-child) {
			margin-bottom: 1rem;
		}
	}

	&__title.mdc-typography--headline2 {
		width: 100%;
		line-height: 1.3;

		@include ln-mq-mobile {
			font-size: 1.5rem;
		}
	}

	&__substep {
		&.ln-form__fieldset {
			margin-left: 2.5em;
			margin-top: 2em;
			margin-bottom: 2em;
		}
	}
	&__substep[disabled='true'],
	&__substep[disabled='disabled'] {
		opacity: 0.3;
	}

	&__details {
		p + ul {
			margin-top: -1.4em;
		}
	}
}
</style>
